class TableIconReplacer {
  constructor() {
    this.lang = this.getLang();
    this.langPrefix = this.getLangPrefix();
    this.replaceIcons();
  }

  getLang() {
    if (document.body.classList.contains('pdf')) {

      const articles = document.querySelectorAll('div.srl-chapter div.srl-article');
      for (let article of articles) {
        const langElement = article.closest('[lang]');
        if (langElement) {
          return langElement.getAttribute('lang').toLowerCase();
        }
      }
      return 'de';
    } else {
      return document.documentElement.lang.toLowerCase();
    }
  }

  getLangPrefix() {
    switch (this.lang) {
      case 'de':
        return 'D';
      case 'en':
        return 'E';
      default:
        return 'D';
    }
  }

  replaceIcons() {
    const tableContainers = document.querySelectorAll('.srl-table-container > table');
    if (tableContainers.length > 0) {
      tableContainers.forEach((tableContainer) => {
        const cells = tableContainer.querySelectorAll('td.srl-horizontal-left.ns-horizontal-left');
        cells.forEach(cell => {
          const span = cell.querySelector('p > span');
          if (span && span.textContent) {
            const match = span.textContent.match(/(?:D|E)-WEB-Goal-(\d+)\.png/);
            if (match) {
              const iconNumber = match[1].padStart(2, '0');
              const iconFileName = this.langPrefix + '-WEB-Goal-' + iconNumber + '.min.svg';
              const img = document.createElement('img');

              if (document.body.classList.contains('pdf')) {
                img.src = 'https://nswow-ld.nswow.ch/designs/rieter-ld/25.0.2/svg/' + iconFileName;
              } else {
                img.src = '../svg/' + iconFileName;
              }
              img.classList.add('img-sdg');
              cell.innerHTML = '';
              cell.appendChild(img);
            }
          }
        });
      });
    }
  }
}

export default TableIconReplacer;
